import { IDocumentFolderModel } from '@api/models';
import { updateDocumentFolder } from '@api/services/document.service';
import { useMutation } from '@tanstack/react-query';

import { useMemo } from 'react';

interface UpdateFolderOptions {
    clientId: string;
    folder: IDocumentFolderModel;
}

const useUpdateFolderForm = (options: UpdateFolderOptions) => {
    const { folder, clientId } = options;

    const initialValues = useMemo(() => {
        if (!folder)
            return {
                name: '',
            };

        return {
            name: folder.name,
        };
    }, [folder]);

    const updateFolderMutation = useMutation((payload: Pick<IDocumentFolderModel, 'name'>) =>
        updateDocumentFolder(clientId, folder._id, payload)
    );

    const submit = async (values: Pick<IDocumentFolderModel, 'name'>) => {
        const updatedFolder = await updateFolderMutation.mutateAsync(values);

        return updatedFolder;

        // return produce(category, (draftState) => {
        //     draftState.name = updatedCategory.name;

        //     return draftState;
        // });

        // return DocumentFolderModel.fromObject({ ...category.toObject(), name: updatedFolder.name });
    };

    return {
        isLoading: updateFolderMutation.isLoading,
        initialValues,
        submit,
    };
};

export default useUpdateFolderForm;
